import { render, staticRenderFns } from "./MainFormRestore.vue?vue&type=template&id=e1faddb2&"
import script from "./MainFormRestore.vue?vue&type=script&lang=js&"
export * from "./MainFormRestore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../var/www/pulse/pulse_client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports